import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/_shadcn-ui/tooltip';
import { TLabelTicket } from '@/features/ticketing/label-tickets/types/label-ticket.type';
import { memo } from 'react';

// Component to render label option in dropdown
type LabelOptionProps = {
  option: TLabelTicket | null;
};
const LabelOption = memo(({ option }: LabelOptionProps) => {
  return (
    <div
      className="flex items-center gap-[8px] px-[6px] py-[2px] w-fit h-fit rounded-[4px]"
      style={{ backgroundColor: option?.color || '#D9D9D9' }}
    >
      <span className="text-[12px] font-[400] text-[#25151E] block">{option?.name || 'Untitled'}</span>
    </div>
  );
});
LabelOption.displayName = 'LabelOption';

// Component to render selected label item
type SelectedLabelItemProps = {
  option: TLabelTicket | null;
  onRemove: (option: TLabelTicket | null) => void;
};
const SelectedLabelItem = memo(({ option, onRemove }: SelectedLabelItemProps) => {
  return (
    <div
      className="flex items-center gap-[8px] border px-[4px] py-[2px] relative rounded-[4px]"
      style={{ backgroundColor: option?.color || '#D9D9D9' }}
    >
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="text-[12px] font-[400] text-[#25151E] block">
            {(option?.name || 'Untitled').length > 12
              ? (option?.name || 'Untitled').slice(0, 12) + '...'
              : option?.name || 'Untitled'}
          </span>
        </TooltipTrigger>
        <TooltipContent className="z-[100001] bg-white text-[#25151E] text-[12px] font-normal p-2 rounded-lg border">
          <span className="text-[12px] font-[400] text-[#25151E]">{option?.name || 'Untitled'}</span>
        </TooltipContent>
      </Tooltip>
      <div
        onClick={(e) => {
          e.stopPropagation();
          onRemove(option);
        }}
        className="hover:opacity-70 cursor-pointer ml-1"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M10.5 3.5L3.5 10.5" stroke="#25151E" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M3.5 3.5L10.5 10.5" stroke="#25151E" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
    </div>
  );
});
SelectedLabelItem.displayName = 'SelectedLabelItem';

export { LabelOption, SelectedLabelItem };
